<template>
    <div>
        <div class="mb20">
            An initial payment of <span v-html="firstAmount"></span>, followed
            by {{ order.instalmentPlan.instalment_count - 1 }} instalments of
            <span v-html="recurringAmount"></span>:
        </div>
        <div class="instalments-list">
            <div
                v-for="instalment in order.instalmentPlan.instalment_dates"
                :key="instalment.collection_date"
                class="instalments-list-item"
            >
                <span class="instalment-date"
                    >{{ instalment.collection_date }}:</span
                >
                <span
                    class="instalment-price"
                    v-html="
                        currency.symbol +
                        parseFloat(instalment.amount / 100).toFixed(2)
                    "
                ></span>
            </div>
        </div>
        <a class="button btn btn--tertiary" href="/booking/stripedd/setup"
            >Continue</a
        >
    </div>
</template>

<script>
export default {
    props: {
        order: {
            type: Object,
            required: false,
        },
    },
    data: () => ({
        currency: window.currency,
    }),
    computed: {
        firstAmount() {
            if (!this.order) return null;
            return (
                currency.symbol +
                "" +
                parseFloat(this.order.instalmentPlan.instalments_amount_first_payment).toFixed(2)
            );
        },
        recurringAmount() {
            if (!this.order) return "";
            return (
                currency.symbol +
                "" +
                parseFloat(this.order.instalmentPlan.instalment_price).toFixed(2)
            );
        },
    },
    mounted() {},
    methods: {},
};
</script>
<style lang="scss" scoped>
.instalments-list {
    margin-bottom: 20px;
    .instalments-list-item {
        padding-bottom: 10px;
        .instalment-date {
            display: inline-block;
            min-width: 90px;
        }
        .instalment-price {
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Checkout/Gateway/Stripedirectdebit.vue